import React from 'react'
import { useTranslation } from 'react-i18next'

import type { SerializedStyles } from '@emotion/react'
import { css } from '@emotion/react'
import Link from 'next/link'

import { FireworkLogo } from '@core/assets/FireworkLogo'
import { FireworkLogoText } from '@core/assets/FireworkLogoText'

interface Props {
  href?: string
  width?: number
  css?: Array<SerializedStyles>
}

/**
 *
 */
export const Logo = ({ href, width, ...props }: Props) => {
  const { t } = useTranslation()
  return (
    <div {...props}>
      <Link
        href={href || '/'}
        className="cy-logo"
        css={css`
          display: block;
          &:hover {
            text-decoration: none;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            justify-content: flex-start;
            width: ${width || 140}px;
            height: ${width ? 0.17 * width : 24}px;
          `}
        >
          <FireworkLogo width="29%" label={t('Firework logo')} />
          <FireworkLogoText
            style={{ marginLeft: '6%', width: '65%' }}
            label={t('Firework')}
          />
        </div>
      </Link>
    </div>
  )
}
